import { TOKEN_ADDRESS_BY_CHAIN } from '@ui/services/contract/constants';
import { ChainId } from '@ui/types/chain';
import { ERC20Token, Token } from '@ui/types/token';

import { getNativeToken } from './nativeTokens';

export const USDC = (
  chainId: ChainId.MONAD_MAINNET | ChainId.MONAD_TESTNET,
): ERC20Token =>
  Object.freeze<ERC20Token>({
    symbol: 'USDC',
    decimals: 6,
    address: TOKEN_ADDRESS_BY_CHAIN[chainId].USDC,
    image: '/tokens/USDC.svg',
    displaySymbol: 'USDC',
    isStable: true,
    isNative: false,
    isPayToken: true,
    isPoolToken: true,
    isTradable: false,
  });

export const LVUSD = (
  chainId: ChainId.MONAD_MAINNET | ChainId.MONAD_TESTNET,
): ERC20Token =>
  Object.freeze<ERC20Token>({
    symbol: 'LVUSD',
    decimals: 18,
    address: TOKEN_ADDRESS_BY_CHAIN[chainId].LVUSD,
    image: '/tokens/LVUSD.svg',
    displaySymbol: 'LVUSD',
    isStable: true,
    isNative: false,
    isPayToken: true,
    isPoolToken: true,
    isTradable: false,
  });

export const WMON = (
  chainId: ChainId.MONAD_MAINNET | ChainId.MONAD_TESTNET,
): ERC20Token =>
  Object.freeze<ERC20Token>({
    symbol: 'WMON',
    decimals: 18,
    address: TOKEN_ADDRESS_BY_CHAIN[chainId].WMON,
    image: '/tokens/MON.svg',
    displaySymbol: 'WMON',
    isStable: false,
    isNative: false,
    isPayToken: true,
    isPoolToken: true,
    isTradable: false,
  });

export const LVMON = (
  chainId: ChainId.MONAD_MAINNET | ChainId.MONAD_TESTNET,
): ERC20Token =>
  Object.freeze<ERC20Token>({
    symbol: 'LVMON',
    decimals: 18,
    address: TOKEN_ADDRESS_BY_CHAIN[chainId].LVMON,
    image: '/tokens/LVMON.svg',
    displaySymbol: 'LVMON',
    isStable: false,
    isNative: false,
    isPayToken: true,
    isPoolToken: true,
    isTradable: false,
  });

export const sLVMON = (
  chainId: ChainId.MONAD_MAINNET | ChainId.MONAD_TESTNET,
): ERC20Token =>
  Object.freeze<ERC20Token>({
    symbol: 'sLVMON',
    decimals: 18,
    address: TOKEN_ADDRESS_BY_CHAIN[chainId].sLVMON,
    image: '/tokens/LVMON.svg',
    displaySymbol: 'sLVMON',
    isStable: false,
    isNative: false,
    isPayToken: true,
    isPoolToken: true,
    isTradable: false,
  });

export const LV = (
  chainId: ChainId.MONAD_MAINNET | ChainId.MONAD_TESTNET,
): ERC20Token =>
  Object.freeze<ERC20Token>({
    symbol: 'LV',
    decimals: 18,
    address: TOKEN_ADDRESS_BY_CHAIN[chainId].LV,
    image: '/tokens/LV.svg',
    displaySymbol: 'LV',
    isStable: false,
    isNative: false,
    isPayToken: true,
    isPoolToken: true,
    isTradable: false,
  });

export const Rona = (
  chainId: ChainId.MONAD_MAINNET | ChainId.MONAD_TESTNET,
): ERC20Token =>
  Object.freeze<ERC20Token>({
    symbol: 'Rona',
    decimals: 18,
    address: TOKEN_ADDRESS_BY_CHAIN[chainId].Rona,
    image: '/tokens/LV.svg',
    displaySymbol: 'Rona',
    isStable: false,
    isNative: false,
    isPayToken: true,
    isPoolToken: true,
    isTradable: false,
  });

export const XLV = (
  chainId: ChainId.MONAD_MAINNET | ChainId.MONAD_TESTNET,
): ERC20Token =>
  Object.freeze<ERC20Token>({
    symbol: 'xLV',
    decimals: 18,
    address: TOKEN_ADDRESS_BY_CHAIN[chainId].xLV,
    image: '/tokens/xLV.svg',
    displaySymbol: 'xLV',
    isStable: false,
    isNative: false,
    isPayToken: true,
    isPoolToken: false,
    isTradable: false,
  });

export const StakedXLV = (
  chainId: ChainId.MONAD_MAINNET | ChainId.MONAD_TESTNET,
): ERC20Token =>
  Object.freeze<ERC20Token>({
    symbol: 'sxLV',
    decimals: 18,
    address: TOKEN_ADDRESS_BY_CHAIN[chainId].xLV,
    image: '/tokens/xLV.svg',
    displaySymbol: 'sxLV',
    isStable: false,
    isNative: false,
    isPayToken: true,
    isPoolToken: true,
    isTradable: false,
  });

export const YLV = (
  chainId: ChainId.MONAD_MAINNET | ChainId.MONAD_TESTNET,
): ERC20Token =>
  Object.freeze<ERC20Token>({
    symbol: 'yLV',
    decimals: 18,
    address: TOKEN_ADDRESS_BY_CHAIN[chainId].yLV,
    image: '/tokens/yLV.svg',
    displaySymbol: 'yLV',
    isStable: false,
    isNative: false,
    isPayToken: true,
    isPoolToken: true,
    isTradable: false,
  });

export const getBaseTokenList = (chainId: ChainId): Token[] => {
  return [getNativeToken(chainId), ...getErc20TokenList(chainId)];
};

export const getErc20TokenList = (chainId: ChainId): ERC20Token[] => {
  const tokens = [
    USDC(chainId),
    LVUSD(chainId),
    WMON(chainId),
    LVMON(chainId),
    LV(chainId),
    XLV(chainId),
    YLV(chainId),
  ];

  if (chainId === ChainId.MONAD_TESTNET) {
    tokens.push(Rona(chainId));
  }

  return tokens;
};
